import * as React from "react";
import { JSX } from "react/jsx-runtime";

const SVGComponent = (props: JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>) => (
  <svg
    width={16}
    height={18}
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.81957 9.62791C5.16562 9.62791 3.00562 7.46791 3.00562 4.81395C3.00562 2.16 5.16562 0 7.81957 0C10.4735 0 12.6335 2.16 12.6335 4.81395C12.6335 7.46791 10.4735 9.62791 7.81957 9.62791ZM7.81957 1.25581C5.8605 1.25581 4.26143 2.85488 4.26143 4.81395C4.26143 6.77302 5.8605 8.37209 7.81957 8.37209C9.77864 8.37209 11.3777 6.77302 11.3777 4.81395C11.3777 2.85488 9.77864 1.25581 7.81957 1.25581Z"
      fill="#1F2A37"
    />
    <path
      d="M15.0111 17.9999C14.6679 17.9999 14.3832 17.7153 14.3832 17.372C14.3832 14.4837 11.4363 12.1395 7.81957 12.1395C4.20278 12.1395 1.25581 14.4837 1.25581 17.372C1.25581 17.7153 0.971163 17.9999 0.627907 17.9999C0.284651 17.9999 0 17.7153 0 17.372C0 13.7972 3.5079 10.8837 7.81957 10.8837C12.1312 10.8837 15.639 13.7972 15.639 17.372C15.639 17.7153 15.3544 17.9999 15.0111 17.9999Z"
      fill="#1F2A37"
    />
  </svg>
);

export default SVGComponent;
